import CredentialAuth from "@/components/auth/CredentialAuth";

export default function CoachLogin() {
  return (
    <CredentialAuth
      role="coach"
      eyebrow="Coach access"
      title="Coach Portal"
      description="Plan sessions, review client progress, manage feedback and keep every athlete moving with purpose."
      allowGoogle
      notice="Coach credentials are issued by the platform administrator. Contact your admin if you do not have access."
    />
  );
}
